const LS_KEY = 'auth_token';
const LS_FC_KEY = '__fc_data__'; // Legacy key kept for backward compatibility with new chatbot
const CB_KEY = 'url';
const LS_SHOW_GAMEPLAY_ONLY = 'LS_SHOW_GAMEPLAY_ONLY';
const LS_FEEDBACK_ALLOWED = 'LS_FEEDBACK_ALLOWED';
const LOGOS_URLS = 'companies_logos';
const LS_TK_EX = 'ck';
const LS_LINK_KEY = 'link';
const LS_ORG_INFO = "orgInfo";
const LS_ORG_ID = 'org_id'
const LS_ALL_TABS_KEY = 'all_tab_switch';
const LS_USER_REF_IMG = 'user_ref_img'
const LS_CG_STAT = 'config_stat';
const LS_WEB_CAM = 'webcam_device';
const LS_MIC = 'mic_device';
const LS_LG_TYPE = 'login_type';
const LS_FB_BOOL = 'isFeedbackSubmitted'
const LS_DISQUALIFIED_BOOL = 'userDisqualified'
const LS_USER_VIDEO_SESSION = 'user_video_session_id'
const LS_SCREEN_VIDEO_SESSION = 'screen_video_session_id'
const LS_USER_VIDEO_ORDER = 'user_video_order_count'
const LS_SCREEN_VIDEO_ORDER = 'screen_video_order_count'
const LS_USER_AUDIO_SESSION = 'user_audio_session_id'
const LS_USER_AUDIO_ORDER = 'user_audio_order_count'
const LS_USER_LANG = 'user_lang'
const LS_LATEST_SNAPSHOT = 'latest_snapshot'
const LS_SUPPORT_TOOLTIP_DISMISSED = 'supportTooltipDismissed'
// let storageType = checkStorage();
// function checkStorage() {
//   window.localStorage.setItem('ex-fg', 'check');
//   if (window.localStorage.getItem('ex-fg')) return 'localStorage';
//   else return 'sessionStorage';
// }

const set = {
  authToken: (data) => {
    localStorage.setItem(LS_KEY, JSON.stringify(data));
  },
  lastLevelPlayed: (data) => {
    localStorage.setItem('last_level', JSON.stringify(data));
  },
  listOfPlayedGamesIds: (data) => {
    localStorage.setItem('list_of_played_game_ids', JSON.stringify(data));
  },
  fcData: (data) => {
    localStorage.setItem(LS_FC_KEY, JSON.stringify(data));
  },
  url: (data) => {
    localStorage.setItem(CB_KEY, JSON.stringify(data));
  },
  showGameplayOnly: (data) => {
    sessionStorage.setItem(LS_SHOW_GAMEPLAY_ONLY, JSON.stringify(data));
  },
  feedbackAllowed: (data) => {
    sessionStorage.setItem(LS_FEEDBACK_ALLOWED, JSON.stringify(data));
  },
  companiesLogos: (data) => {
    localStorage.setItem(LOGOS_URLS, JSON.stringify(data));
  },
  tokenExpiry: (data) => {
    localStorage.setItem(LS_TK_EX, JSON.stringify(data));
  },
  linkId: (data) => {
    localStorage.setItem(LS_LINK_KEY, JSON.stringify(data));
  },
  allTabSwitchCount: (count) => {
    const { id: userId } = storage.get.fcData()
    localStorage.setItem(`${LS_ALL_TABS_KEY}-${userId}`, JSON.stringify(count));
  },
  userRefImg: (data) => {
    const linkId = storage.get.linkId()
    localStorage.setItem(`${LS_USER_REF_IMG}-${linkId}`, JSON.stringify(data));
  },
  configStat: (data) => {
    localStorage.setItem(LS_CG_STAT, JSON.stringify(data));
  },
  webCam: (data) => {
    localStorage.setItem(LS_WEB_CAM, JSON.stringify(data));
  },
  micDevice: (data) => {
    localStorage.setItem(LS_MIC, JSON.stringify(data));
  },
  loginType: (data) => {
    localStorage.setItem(LS_LG_TYPE, JSON.stringify(data))
  },
  isFeedbackSubmitted: (userId) => {
    localStorage.setItem(`${LS_FB_BOOL}-${userId}`, JSON.stringify(true))
  },
  userDisqualified: () => {
    sessionStorage.setItem(LS_DISQUALIFIED_BOOL, JSON.stringify(true))
  },
  userVideoSessionId: (data) => {
    localStorage.setItem(LS_USER_VIDEO_SESSION, JSON.stringify(data))
  },
  screenVideoSessionId: (data) => {
    localStorage.setItem(LS_SCREEN_VIDEO_SESSION, JSON.stringify(data))
  },
  userVideoOrderCount: (data) => {
    localStorage.setItem(LS_USER_VIDEO_ORDER, JSON.stringify(data))
  },
  userAudioSessionId: (data) => {
    localStorage.setItem(LS_USER_AUDIO_SESSION, JSON.stringify(data))
  },
  userAudioOrderCount: (data) => {
    localStorage.setItem(LS_USER_AUDIO_ORDER, JSON.stringify(data))
  },
  screenVideoOrderCount: (data) => {
    localStorage.setItem(LS_SCREEN_VIDEO_ORDER, JSON.stringify(data))
  },
  orgInfo: (data) => {
    localStorage.setItem(LS_ORG_INFO, JSON.stringify(data))
  },
  orgId: (data) => {
    localStorage.setItem(LS_ORG_ID, JSON.stringify(data))
  },
  userLang: (data) => {
    sessionStorage.setItem(LS_USER_LANG, JSON.stringify(data))
  },
  latestSnapshot: (data, linkId) => {
    sessionStorage.setItem(`${LS_LATEST_SNAPSHOT}-${linkId}`, JSON.stringify(data))
  },
  supportTooltipDismissed: () => {
    localStorage.setItem(LS_SUPPORT_TOOLTIP_DISMISSED, JSON.stringify(true))
  },
};

const get = {
  authToken: () => {
    return JSON.parse(localStorage.getItem(LS_KEY));
  },
  lastLevelPlayed: () => {
    return JSON.parse(localStorage.getItem('last_level'));
  },
  listOfPlayedGamesIds: () => {
    return JSON.parse(localStorage.getItem('list_of_played_game_ids'));
  },
  fcData: () => {
    return JSON.parse(localStorage.getItem(LS_FC_KEY));
  },
  url: () => {
    return JSON.parse(localStorage.getItem(CB_KEY));
  },
  showGameplayOnly: () => {
    return JSON.parse(sessionStorage.getItem(LS_SHOW_GAMEPLAY_ONLY));
  },
  feedbackAllowed: () => {
    return JSON.parse(sessionStorage.getItem(LS_FEEDBACK_ALLOWED));
  },
  companiesLogos: () => {
    return JSON.parse(localStorage.getItem(LOGOS_URLS));
  },
  tokenExpiry: () => {
    return JSON.parse(localStorage.getItem(LS_TK_EX));
  },
  linkId: () => {
    return JSON.parse(localStorage.getItem(LS_LINK_KEY));
  },
  allTabSwitchCount: () => {
    const { id: userId } = storage.get.fcData()
    return JSON.parse(localStorage.getItem(`${LS_ALL_TABS_KEY}-${userId}`));
  },
  userRefImg: () => {
    const linkId = storage.get.linkId()
    return JSON.parse(localStorage.getItem(`${LS_USER_REF_IMG}-${linkId}`));
  },
  configStat: () => {
    return JSON.parse(localStorage.getItem(LS_CG_STAT));
  },
  webCam: () => {
    return JSON.parse(localStorage.getItem(LS_WEB_CAM));
  },
  micDevice: () => {
    return JSON.parse(localStorage.getItem(LS_MIC));
  },
  loginType: () => {
    return JSON.parse(localStorage.getItem(LS_LG_TYPE));
  },
  isFeedbackSubmitted: (userId) => {
    return JSON.parse(localStorage.getItem(`${LS_FB_BOOL}-${userId}`));
  },
  userDisqualified: () => {
    return JSON.parse(sessionStorage.getItem(LS_DISQUALIFIED_BOOL));
  },
  userVideoSessionId: () => {
    return JSON.parse(localStorage.getItem(LS_USER_VIDEO_SESSION));
  },
  screenVideoSessionId: () => {
    return JSON.parse(localStorage.getItem(LS_SCREEN_VIDEO_SESSION));
  },
  userVideoOrderCount: () => {
    return JSON.parse(localStorage.getItem(LS_USER_VIDEO_ORDER));
  },
  screenVideoOrderCount: () => {
    return JSON.parse(localStorage.getItem(LS_SCREEN_VIDEO_ORDER));
  },
  userAudioSessionId: () => {
    return JSON.parse(localStorage.getItem(LS_USER_AUDIO_SESSION));
  },
  userAudioOrderCount: () => {
    return JSON.parse(localStorage.getItem(LS_USER_AUDIO_ORDER));
  },
  orgInfo: () => {
    return JSON.parse(localStorage.getItem(LS_ORG_INFO));
  },
  orgId: () => {
    return JSON.parse(localStorage.getItem(LS_ORG_ID));
  },
  userLang: () => {
    return JSON.parse(sessionStorage.getItem(LS_USER_LANG));
  },
  latestSnapshot: (linkId) => {
    return JSON.parse(sessionStorage.getItem(`${LS_LATEST_SNAPSHOT}-${linkId}`))
  },
  supportTooltipDismissed: () => {
    return JSON.parse(localStorage.getItem(LS_SUPPORT_TOOLTIP_DISMISSED))
  },
};

const destroy = {
  authToken: () => {
    localStorage.removeItem(LS_KEY);
  },
  fcData: () => {
    localStorage.removeItem(LS_FC_KEY);
  },
  url: () => {
    localStorage.removeItem(CB_KEY);
  },
  showGameplayOnly: () => {
    sessionStorage.removeItem(LS_SHOW_GAMEPLAY_ONLY);
  },
  feedbackAllowed: () => {
    sessionStorage.removeItem(LS_FEEDBACK_ALLOWED);
  },
  configStat: () => {
    localStorage.removeItem(LS_CG_STAT);
  },
  webCam: () => {
    localStorage.removeItem(LS_WEB_CAM);
  },
  companiesLogos: () => {
    localStorage.removeItem(LOGOS_URLS);
  },
  tabSwitchCounts: (userId) => {
    localStorage.removeItem(`${LS_ALL_TABS_KEY}-${userId}`);
  },
  listOfPlayedGamesIds: () => {
    localStorage.removeItem('list_of_played_game_ids')
  },
  userDisqualified: () => {
    sessionStorage.removeItem(LS_DISQUALIFIED_BOOL);
  },
  tokenExpiry: () => {
    localStorage.removeItem(LS_TK_EX);
  },
  userRefImg: () => {
    const linkId = storage.get.linkId()
    localStorage.removeItem(`${LS_USER_REF_IMG}-${linkId}`);
  },
  micDevice: () => {
    localStorage.removeItem(LS_MIC);
  },
  userVideoSessionId: () => {
    localStorage.removeItem(LS_USER_VIDEO_SESSION);
  },
  screenVideoSessionId: () => {
    localStorage.removeItem(LS_SCREEN_VIDEO_SESSION);
  },
  userVideoOrderCount: () => {
    localStorage.removeItem(LS_USER_VIDEO_ORDER);
  },
  screenVideoOrderCount: () => {
    localStorage.removeItem(LS_SCREEN_VIDEO_ORDER);
  },
  orgId: () => {
    localStorage.removeItem(LS_ORG_ID);
  },
  all: () => {
    const logos = storage.get.companiesLogos()
    const orgInfo = storage.get.orgInfo()
    localStorage.clear()
    storage.set.companiesLogos(logos)
    storage.set.orgInfo(orgInfo)
  },
  supportTooltipDismissed: () => {
    localStorage.removeItem(LS_SUPPORT_TOOLTIP_DISMISSED)
  },
  latestSnapshot: () => {
    const linkId = storage.get.linkId()
    sessionStorage.removeItem(`${LS_LATEST_SNAPSHOT}-${linkId}`)
  },
  allExceptFeedbackSubmittedAndUserDisqualified: (userId) => {
    storage.destroy.listOfPlayedGamesIds()
    storage.destroy.url()
    storage.destroy.webCam()
    storage.destroy.tabSwitchCounts(userId)
    storage.destroy.fcData()
    storage.destroy.userRefImg()
    storage.destroy.latestSnapshot()
    storage.destroy.micDevice()
    storage.destroy.userVideoSessionId()
    storage.destroy.screenVideoSessionId()
    storage.destroy.userVideoOrderCount()
    storage.destroy.screenVideoOrderCount()
    storage.destroy.orgId()
    storage.destroy.supportTooltipDismissed()
  },

};

export const storage = {
  set,
  get,
  destroy,
};
